import { ChatButton } from "../../components/ChatButton";
import { Chat } from "../../components/Chat";
import Tabs from "../../components/Common/CustomTabs/CustomTabs";
import { useState, useEffect } from "react";
import { useParams, useSearchParams, useLocation } from "react-router-dom";
import {
	useNegotiationsStore,
	type Negotiation,
} from "../../stores/negotiationsStore";
import { useNavigationContextStore } from "../../stores/navigationContextStore";
import "./AiPage.scss";
import Analysis from "../../components/Analysis/Analysis";
import ScenarioPlanning from "../../components/ScenarioPlanning/ScenarioPlanning";
import TargetsTactics from "../../components/TargetsTactics/TargetsTactics";
import BriefingDocument from "../../components/BriefingDocument/BriefingDocument";

interface TabItem {
	key: string;
	label: string;
	disabled?: boolean;
}
const AiPage: React.FC = () => {
	const { negotiation_id } = useParams<{ negotiation_id?: string }>();
	const location = useLocation();
	const [searchParams] = useSearchParams();
	const { fetchNegotiationById } = useNegotiationsStore();
	const { activeTab, setActiveTab, initializeFromURL, updateURL } = useNavigationContextStore();
	const [currentNegotiation, setCurrentNegotiation] =
		useState<Negotiation | null>(null);
	const [loading, setLoading] = useState(false);
	const tabItem: TabItem[] = [
		{ key: "analysis", label: "Analysis", disabled: false },
		{
			key: "scenario",
			label: "Scenario Planning",
			disabled: false,
		},
		{
			key: "targets-new",
			label: "Targets & Strategies",
			disabled: false,
		},
		{
			key: "briefing",
			label: "Briefing Document",
			disabled: false,
		},
	];

	// Initialize navigation state from URL on component mount
	useEffect(() => {
		initializeFromURL(searchParams);
	}, [initializeFromURL, searchParams]);

	useEffect(() => {
		const loadNegotiation = async () => {
			if (!negotiation_id) return;

			setLoading(true);

			try {
				const negotiation = await fetchNegotiationById(
					parseInt(negotiation_id)
				);
				setCurrentNegotiation(negotiation);
			} catch (error) {
				console.error("Error loading negotiation:", error);
				setCurrentNegotiation(null);
			} finally {
				setLoading(false);
			}
		};

		loadNegotiation();
	}, [negotiation_id, fetchNegotiationById]);

	if (negotiation_id && !loading && !currentNegotiation) {
		return (
			<div className="flex items-center justify-center h-64">
				<div className="text-center">
					<i className="pi pi-exclamation-triangle text-2xl mb-2 text-yellow-500"></i>
					<p>Negotiation not found</p>
				</div>
			</div>
		);
	}

	return (
		<div>
			<Tabs
				tabs={tabItem}
				activeTab={activeTab}
				setActiveTab={(tab: string) => {
					setActiveTab(tab);
					// Update URL when tab changes
					setTimeout(() => updateURL(location.pathname), 0);
				}}
			/>

			{/* based on active tab render different component */}
			<div className="tab-conatiner">
				{activeTab === "analysis" && <Analysis />}
				{activeTab === "targets-new" && <TargetsTactics />}
				{activeTab === "scenario" && <ScenarioPlanning />}
				{activeTab === "briefing" && <BriefingDocument />}
			</div>
			<ChatButton />
			<Chat />
		</div>
	);
};

export default AiPage;
